export const getPartnerDuration = (
  startDate: string,
): { count: number; units: 'years' | 'months' } => {
  const start = new Date(startDate);

  // Guard invalid input (e.g. an empty or malformed date string) so the
  // duration never comes out as NaN.
  if (Number.isNaN(start.getTime())) {
    return { count: 0, units: 'months' };
  }

  const now = new Date();

  // Use UTC getters throughout: date-only strings (e.g. "2015-01-24") parse as
  // UTC midnight, so reading them with local getters would shift the day/month
  // in behind-UTC timezones and make the result timezone-dependent.
  const yearsDiff = now.getUTCFullYear() - start.getUTCFullYear();
  const monthsDiff = now.getUTCMonth() - start.getUTCMonth();
  const daysDiff = now.getUTCDate() - start.getUTCDate();

  let totalMonths = yearsDiff * 12 + monthsDiff;

  // Adjust if the day of the month hasn't been reached yet
  if (daysDiff < 0) {
    totalMonths -= 1;
  }

  if (totalMonths < 12) {
    return { count: Math.max(0, totalMonths), units: 'months' };
  }

  const years = Math.floor(totalMonths / 12);
  return { count: years, units: 'years' };
};
